import { Box, Popover, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import ButtonTabs from "../../../Components/ButtonTabs/ButtonTabs";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import { Modal } from "react-bootstrap";
import notify from "../../../Helpers/ToastNotification";
import { APICall } from "../../../Helpers/Network/APICalls";
// import { insertIntoMemberEnrollmentHistory } from "../../Helpers/APIEndPoints/EndPoints";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonForm from "../../../Components/ButtonForm/ButtonForm";
import { ApplicationStatus, LoanRepayment } from "../../../Helpers/Enums/ApplicationStatus";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import { RiFileListLine } from "react-icons/ri";
import { makeStyles } from "@mui/styles";
import { Modules } from "../../../Helpers/Enums/Modules";
import { loggedRoleStatus } from "../../../Helpers/Enums/Enum";
import { Decrypt } from "../../../Helpers/Cryptography/Crypto";
import PaymentDetails from "./PaymentDetails";
import LoanRepaymentDetails from "./LoanRepaymentDetails";
import LoanDetailsMemberView from "./LoanDetailsMemberView";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const LoanSettlementTabs = () => {
  let navigate = useNavigate();
  const { state } = useLocation();
  if (state == null) {
    navigate("/LoanApprovalDashboard");
  }
  
  const { LoanRequestId, LoanRepaymentId, Status, RepaymentAmount } = state;
  const location = useLocation();
  const [value, setValue] = React.useState(0);
  const context = getContext();

  const [isViewMode] = useState<boolean>(![0, LoanRepayment.LoanRepayment_InternalTeamSendBackLoanRepayment].includes(Status));
  const storedVisitCount = localStorage.getItem("loanSettlementTabsVisitCount");
  const submittedRepaymntCount = localStorage.getItem("loanSettlementTabssubmitted");
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  //const memberid = localStorage.getItem("MemberId") || "";
  const [tabsStatus, setTabsStatus] = React.useState([true, true]);
  const tabs = [
    { label: "Repayment Details", visible: true, value: { ...a11yProps(0) } },
    { label: "payment Details", visible: Status > LoanRepayment.LoanRepayment_InternalTeamSendBackLoanRepayment, value: { ...a11yProps(1) } },
  ];

  const selectNextTab = (index: any) => {
    let val = value + 1;
    setValue(val);
    setTabsStatus((prevStatus) => prevStatus.map((d, i) => (i <= index ? (d = false) : (d = true))));
  };

  const selectPreviousTab = (index: any) => {
    setValue(value - 1);

    setTabsStatus((prevStatus) => prevStatus.map((d, i) => (i <= index ? (d = false) : (d = true))));
  };

  const HandleNextPrv = () => {
    let next = false;
    let prev = false;
    if (context?.loggedInAs?.value !== RoleEnum.HRHOD) {
      if ([5, 4, 3, 2, 1].includes(value)) {
        prev = true;
      }
      if ([4, 3, 2, 1, 0].includes(value)) {
        next = true;
      }
    } else {
      if ([4, 3, 2, 1].includes(value)) {
        prev = true;
      }
      if ([3, 2, 1, 0].includes(value)) {
        next = true;
      }
    }

    return (
      <>
        <ButtonComponent
          icon={"fa-solid"}
          value={"Cancel"}
          style={{ marginLeft: "10px" }}
          className="btn btn-primary"
          onClick={() => navigate("/MemberVerification")}
        />

        {prev && <ButtonComponent icon={"fas fa-arrow-left"} value={"Previous"} style={{ marginLeft: "10px" }} id={"saveBtn"} onClick={selectPreviousTab} />}
        {next && <ButtonComponent icon={"fas fa-arrow-right"} value={"Next"} style={{ marginLeft: "10px" }} id={"saveBtn"} onClick={selectNextTab} />}
      </>
    );
  };

  let tabTrue = false;
  if (value === 5 && context?.loggedInAs?.value !== RoleEnum.HRHOD) {
    tabTrue = true;
  } else if (value === 4 && context?.loggedInAs?.value === RoleEnum.HRHOD) {
    tabTrue = true;
  }

  return (
    <>
      <div>
        {/* <Box sx={{ width: "100%" }}>
          <ButtonTabs value={value} handleChange={handleChange} tabs={tabs} />         
          <CustomTabPanel value={value} index={0}>
            <LoanRepaymentDetails
              selectNextTab={(index) => selectNextTab(1)}
              selectPreviousTab={selectPreviousTab}
            />
          </CustomTabPanel>
          
          <CustomTabPanel value={value} index={1}>
            <PaymentDetails
              selectNextTab={() => selectNextTab(2)}
              selectPreviousTab={(index) => selectPreviousTab(1)}
            />
          </CustomTabPanel>        
          
        </Box> */}
        <Box sx={{ width: "100%" }}>
          <ButtonTabs value={value} handleChange={handleChange} tabs={tabs.filter((t) => t.visible)} />

          {tabs.map((tab, index) => {
            if (!tab.visible) return null;
            return (
              <CustomTabPanel key={index} value={value} index={index}>
                {tab.label === "Repayment Details" && (
                  <LoanRepaymentDetails
                    selectNextTab={(nextIndex) => selectNextTab(nextIndex)}
                    selectPreviousTab={(prevIndex) => selectPreviousTab(prevIndex)}
                    LoanRequestId={LoanRequestId}
                    LoanRepaymentId={LoanRepaymentId}
                    Status={Status}
                  />
                )}
                {tab.label === "payment Details" && (
                  <PaymentDetails
                    selectNextTab={(nextIndex) => selectNextTab(nextIndex)}
                    selectPreviousTab={(prevIndex) => selectPreviousTab(prevIndex)}
                    LoanRequestId={LoanRequestId}
                    LoanRepaymentId={LoanRepaymentId}
                    Status={Status}
                    RepaymentAmount={RepaymentAmount}
                  />
                )}
              </CustomTabPanel>
            );
          })}
        </Box>
      </div>
    </>
  );
};

export default LoanSettlementTabs;
